import React from "react";
const AppConfigContext = React.createContext({
   theme:"theme-default",
    handleTheme:()=>{}
});
export default AppConfigContext;